@if (isVisible) {
  <div class="fixed inset-0 bg-black/50 z-[999] flex items-center justify-center" (click)="close()">
    <div class="bg-white text-bosch-gray-900 p-8 border border-bosch-gray-200 rounded-xl shadow-2xl max-w-[500px] w-[90%] max-h-[90vh] overflow-y-auto font-bosch" (click)="$event.stopPropagation()">
      <!-- Title -->
      <h3 class="text-bosch-h3 font-bosch-strong text-bosch-gray-900 mb-bosch-lg">
        {{ items.length > 1 ? 'Bulk Share Links' : 'Share Ownership' }}
      </h3>
      <!-- Link Information -->
      <div class="mb-bosch-lg p-bosch-md bg-bosch-gray-50 rounded-bosch-md border border-bosch-gray-200">
        <p class="text-sm text-bosch-gray-700 mb-bosch-xs">
          <strong>{{ items.length > 1 ? ('Links (' + items.length + '):') : 'Short URL:' }}</strong>
        </p>
        <p class="text-sm text-bosch-blue-600 break-all">{{ getLinksDisplayText() }}</p>
      </div>
      <!-- Users Input Section (always shown) -->
      <div class="mb-bosch-lg">
        <label class="block text-sm font-bosch-medium text-bosch-gray-900 mb-bosch-sm">
          Users who have access:
        </label>
        <!-- Input field for adding users -->
        <div class="mb-bosch-md">
          <div class="flex gap-bosch-sm relative">
            <div class="flex-1 relative">
              <input
                type="text"
                [(ngModel)]="newUserEmail"
                (input)="onEmailInput(newUserEmail)"
                (keydown.enter)="addUser()"
                (blur)="closeDropdown()"
                placeholder="Enter email or name to search"
                class="w-full px-bosch-md py-bosch-sm border rounded-bosch-md text-sm focus:outline-none focus:ring-2 transition-colors pr-10"
              [ngClass]="{
                'border-bosch-gray-300 focus:ring-bosch-blue-500 focus:border-bosch-blue-500': !emailValidationResult,
                'border-green-500 focus:ring-green-500 focus:border-green-500 bg-green-50': emailValidationResult?.exists === true,
                'border-red-500 focus:ring-red-500 focus:border-red-500 bg-red-50': emailValidationResult && (!emailValidationResult.isValid || !emailValidationResult.exists)
              }" />
                <!-- Validation indicator inside input -->
                <div class="absolute right-3 top-1/2 transform -translate-y-1/2">
                  <!-- Loading spinner (for both email validation and user search) -->
                  @if ((isValidatingEmail || isSearching) && newUserEmail.trim()) {
                    <svg class="animate-spin h-5 w-5 text-bosch-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  }
                  <!-- Green check mark -->
                  @if (!isValidatingEmail && !isSearching && emailValidationResult?.exists === true) {
                    <svg class="h-5 w-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
                    </svg>
                  }
                  <!-- Red X mark -->
                  @if (!isValidatingEmail && !isSearching && emailValidationResult && (!emailValidationResult.isValid || !emailValidationResult.exists)) {
                    <svg class="h-5 w-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                  }
                </div>
                <!-- User search dropdown -->
                @if (showDropdown && searchResults.length > 0) {
                  <div
                    class="absolute z-50 w-full mt-1 bg-white border border-bosch-gray-300 rounded-bosch-md shadow-lg max-h-60 overflow-y-auto">
                    @for (user of searchResults; track user) {
                      <div
                        (mousedown)="selectUser(user)"
                        class="px-bosch-md py-bosch-sm hover:bg-bosch-blue-50 cursor-pointer transition-colors">
                        <div class="text-sm font-bosch-medium text-bosch-gray-900">{{ user.displayName }}</div>
                        <div class="text-xs text-bosch-gray-600">{{ user.userPrincipalName || user.email }}</div>
                      </div>
                    }
                  </div>
                }
              </div>
              <button
                (click)="addUser()"
                [disabled]="!canAddUser()"
                class="px-bosch-md py-bosch-sm bg-bosch-blue-500 hover:bg-bosch-blue-600 disabled:bg-bosch-gray-300 disabled:cursor-not-allowed text-white text-sm font-bosch-medium rounded-bosch-md transition-colors">
                Add
              </button>
            </div>
            <!-- Validation message -->
            @if (emailValidationResult && newUserEmail.trim()) {
              <div class="mt-bosch-xs text-xs">
                @if (emailValidationResult.exists) {
                  <p class="text-green-700 flex items-center gap-1">
                    <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
                    </svg>
                    <span>User found: <strong>{{ emailValidationResult.displayName }}</strong></span>
                  </p>
                }
                @if (!emailValidationResult.isValid) {
                  <p class="text-red-700 flex items-center gap-1">
                    <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                    </svg>
                    <span>{{ emailValidationResult.errorMessage || 'Invalid email format' }}</span>
                  </p>
                }
                @if (emailValidationResult.isValid && !emailValidationResult.exists) {
                  <p class="text-red-700 flex items-center gap-1">
                    <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                    </svg>
                    <span>{{ emailValidationResult.errorMessage || 'User not found in organization' }}</span>
                  </p>
                }
              </div>
            }
          </div>
          <!-- List of shared users -->
          @if (selectedPeople.length > 0) {
            <div class="space-y-bosch-xs max-h-40 overflow-y-auto border border-bosch-gray-200 rounded-bosch-md p-bosch-sm bg-white">
              @for (person of selectedPeople; track person) {
                <div
                  class="flex items-center justify-between gap-bosch-sm p-bosch-sm rounded-bosch-sm transition-colors"
             [ngClass]="{
               'bg-bosch-gray-50 hover:bg-bosch-gray-100': !person.isPartial,
               'bg-bosch-gray-100 opacity-60': person.isPartial
             }">
                  <!-- Avatar Circle -->
                  <div [ngClass]="['flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bosch-strong', getOwnerColor(person.email)]"
                    [class.opacity-50]="person.isPartial">
                    {{ getOwnerInitials(person.email) }}
                  </div>
                  <!-- View Mode -->
                  @if (!person.editing) {
                    <div class="flex-1 min-w-0">
                      <div class="text-sm font-bosch-medium truncate"
                 [ngClass]="{
                   'text-bosch-gray-900': !person.isPartial,
                   'text-bosch-gray-500': person.isPartial
                 }">
                        {{ person.email }}
                      </div>
                      @if (person.isPartial) {
                        <div class="text-xs text-bosch-gray-500 italic">
                          In {{ person.itemCount }} of {{ items.length }} link(s)
                        </div>
                      }
                    </div>
                  }
                  <!-- Edit Mode -->
                  @if (person.editing) {
                    <div class="flex-1 min-w-0">
                      <input
                        type="email"
                        [(ngModel)]="person.tempEmail"
                        placeholder="Email"
                        class="w-full px-2 py-1 text-sm border border-bosch-gray-300 rounded-bosch-sm focus:outline-none focus:ring-1 focus:ring-bosch-blue-500 focus:border-bosch-blue-500">
                      </div>
                    }
                    @if (isCreator(person)) {
                      <span class="flex-shrink-0 px-2 py-0.5 text-xs bg-bosch-blue-100 text-bosch-blue-800 rounded-full">Owner</span>
                    }
                    @if (!isCreator(person)) {
                      <span class="flex-shrink-0 px-2 py-0.5 text-xs bg-bosch-gray-200 text-bosch-gray-700 rounded-full">Member</span>
                    }
                    <!-- Edit Mode Actions -->
                    @if (person.editing) {
                      <div class="flex-shrink-0 flex gap-1">
                        <button
                          (click)="saveEdit(person)"
                          class="p-1 rounded-bosch-sm hover:bg-green-100 transition-colors group"
                          [attr.aria-label]="'Save changes'">
                          <img src="../ui/assets/img/diskette-svgrepo-com.svg" alt="" class="w-5 h-5 opacity-60 group-hover:opacity-100 transition-opacity">
                        </button>
                        <button
                          (click)="cancelEdit(person)"
                          class="p-1 rounded-bosch-sm hover:bg-gray-200 transition-colors group"
                          [attr.aria-label]="'Cancel editing'">
                          <img src="../ui/assets/img/cancel-svgrepo-com.svg" alt="" class="w-5 h-5 opacity-60 group-hover:opacity-100 transition-opacity">
                        </button>
                      </div>
                    }
                    <!-- View Mode Actions -->
                    @if (!person.editing) {
                      <div class="flex-shrink-0 flex gap-1">
                        @if (!isCreator(person)) {
                          <button
                            (click)="startEditing(person)"
                            class="p-1 rounded-bosch-sm hover:bg-blue-100 transition-colors group"
                            [attr.aria-label]="'Edit user ' + person.email">
                            <img src="../ui/assets/img/edit.svg" alt="" class="w-5 h-5 opacity-60 group-hover:opacity-100 transition-opacity">
                          </button>
                        }
                        @if (!isCreator(person)) {
                          <button
                            (click)="removeUser(person)"
                            class="p-1 rounded-bosch-sm hover:bg-pink-100 transition-colors group"
                            [attr.aria-label]="'Remove user ' + person.email">
                            <img src="../ui/assets/img/delete.svg" alt="" class="w-5 h-5 opacity-60 group-hover:opacity-100 transition-opacity">
                          </button>
                        }
                        @if (isCreator(person)) {
                          <span class="w-14"></span>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (selectedPeople.length === 0) {
              <p class="text-xs text-bosch-gray-500 mt-bosch-xs">
                No users added yet. Add users above to share this link with them.
              </p>
            }
          </div>
          <!-- Action Buttons -->
          <div class="flex gap-bosch-md">
            <button
              (click)="close()"
              class="flex-1 bg-white hover:bg-bosch-gray-50 text-bosch-gray-700 font-bosch-medium py-bosch-sm px-bosch-md rounded-bosch-md border-2 border-bosch-gray-300 hover:border-bosch-gray-400 transition-all duration-200 text-center text-sm">
              Cancel
            </button>
            <button
              (click)="apply()"
              [disabled]="!hasChanges()"
              [class.opacity-50]="!hasChanges()"
              [class.cursor-not-allowed]="!hasChanges()"
              class="flex-1 bg-bosch-blue-500 hover:bg-bosch-blue-600 text-white font-bosch-medium py-bosch-sm px-bosch-md rounded-bosch-md border-2 border-bosch-blue-700 hover:border-bosch-blue-800 transition-all duration-200 text-center text-sm disabled:hover:bg-bosch-blue-500 disabled:hover:border-bosch-blue-700">
              Apply
            </button>
          </div>
        </div>
      </div>
    }
